export default {
  name: 'IcRoundChevronLeft'
};